var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomPoolRegular = function SvgCustomPoolRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    style: {
      enableBackground: "new 0 0 640 512"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m284.8 37.9-227 393.2c-15.7 27.1 3.9 61.1 35.2 61.1h454c31.3 0 50.9-33.9 35.2-61.1l-227-393.2c-15.6-27.1-54.8-27.1-70.4 0zm57.4 59.8L524 412.5c9.9 17.1-2.5 38.5-22.2 38.5H138.2c-19.7 0-32.1-21.4-22.2-38.5L297.8 97.7c9.9-17.1 34.5-17.1 44.4 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 181.1,
    r: 45.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 388.3,
    r: 45.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.5,
    cy: 388.3,
    r: 45.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.1,
    cy: 388.3,
    r: 45.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 284.7,
    r: 45.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 284.7,
    r: 45.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.1 42.8 50.4 423.2c-22.2 38.4 5.5 86.5 49.9 86.5h439.3c44.4 0 72.1-48.1 49.9-86.5L369.9 42.8c-22.2-38.5-77.6-38.5-99.8 0zm85.8 64.1L527 403.3c16 27.7-4 62.3-35.9 62.3H148.9c-32 0-51.9-34.6-35.9-62.3L284.1 107c15.9-27.7 55.9-27.7 71.8-.1z"
  }))));
};
export default SvgCustomPoolRegular;